import { render, staticRenderFns } from "./bookComment.vue?vue&type=template&id=b57af53e&scoped=true"
import script from "./bookComment.vue?vue&type=script&lang=js"
export * from "./bookComment.vue?vue&type=script&lang=js"
import style0 from "./bookComment.vue?vue&type=style&index=0&id=b57af53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57af53e",
  null
  
)

export default component.exports